import { HistoricAlertDTO } from "@energy-advice/easas-api";
import { LagLeadLoadingConfig } from "../charts/interfaces";

export type AlertFanEditorProps = {
  itemsPerPage?: number;
  updateFrequency?: number;
  topicTags?: string[];
  itemTags?: string[];
  loadConf?: LagLeadLoadingConfig;
  hiddenColumns?: string[];
  showHistoryByDefault?: boolean;
};

export enum TagsTypes {
  TOPIC_TAGS = "Topic tags",
  ITEM_TAGS = "Item tags",
}

export type AlertsViewProps = {
  itemsPerPage?: number;
  updateFrequency?: number;
  topicTags?: Array<string>;
  itemTags?: Array<string>;
  loadConf?: LagLeadLoadingConfig;
  hiddenColumns?: string[];
  showHistoryByDefault?: boolean;

  setTags: (tags: { topics?: Array<string>; items?: Array<string> }) => void;
  setTab: (n: number) => void;
};

export interface HistoryAlertsTableProps {
  tags: Array<string>;
}

export type HistoryTagsTableProps = {
  data: HistoricAlertDTO[];
};
